var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { BigNumber } from "ethers";
import { useContext } from "react";
import { SubgraphDataContext } from "./subgraphDataContext";
export var governanceTransactionsGraphql = function (account) { return "\n  governanceTransactions(\n    where:{address:\"" + account + "\"},\n    orderBy: timestamp,\n    orderDirection: desc\n  ) {\n    id\n    type\n    amount\n    address\n    txhash\n    timestamp\n  }\n"; };
export var resolveGovernanceTransactionsSubgraphResponse = function (response) {
    return response.governanceTransactions
        ? response.governanceTransactions.map(function (transaction) { return (__assign(__assign({}, transaction), { amount: BigNumber.from(transaction.amount) })); })
        : [];
};
export var useGovernanceTransactions = function () {
    var contextData = useContext(SubgraphDataContext);
    return {
        transactions: contextData.governanceSubgraphData.transactions,
        loading: contextData.governanceSubgraphData.loading,
    };
};
export default useGovernanceTransactions;
//# sourceMappingURL=useGovernanceTransactions.js.map